import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../hooks/useAuth';
import logger from "../../utils/logger";
const initialLogin = {
  email: '',
  password: ''
};
function YandexIcon() {
  return <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M9.84 1.5H7.37c-2.2 0-3.53 1.25-3.53 3.27 0 1.62.92 2.77 2.48 3.13L3.3 14.5h2.52l2.7-6.3h.7v6.3h2.3V1.5h-1.68Zm-.62 4.92H7.53c-.95 0-1.53-.56-1.53-1.5 0-.96.58-1.55 1.53-1.55h1.69v3.05Z" fill="#FC3F1D" />

        </svg>;
}
function VkIcon() {
  return <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M8.42 11.45c-4.06 0-6.37-2.79-6.47-7.43h2.03c.07 3.42 1.57 4.87 2.75 5.17V4.02h1.91v2.95c1.16-.12 2.39-1.47 2.8-2.95h1.91c-.32 1.82-1.66 3.16-2.61 3.71.95.44 2.47 1.6 3.05 3.72h-2.1c-.44-1.42-1.56-2.52-3.05-2.67v2.67h-.22Z" fill="#07F" />

        </svg>;
}
// Вход через Яндекс и VK скрыт, пока на проде не настроены ключи OAuth; код оставлен.
const SOCIAL_LOGIN_ENABLED = false;

function LoginForm() {
  const {
    request,
    showStatus,
    setStatus
  } = useApi();
  const {
    login,
    setUser
  } = useAuth();
  const [form, setForm] = useState(initialLogin);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const handleSubmit = async event => {
    event.preventDefault();
    if (!form.email.trim() || !form.password) {
      showStatus('error', 'Введите email и пароль.');
      return;
    }
    setBusy(true);
    setStatus(null);
    try {
      const tokenResponse = await request('/api/v1/auth/login', {
        method: 'POST',
        body: JSON.stringify(form)
      });
      login(tokenResponse);

      // Load user data with company_id
      try {
        const userData = await request('/api/v1/auth/me');
        if (userData) {
          setUser(userData);
        }
      } catch (err) {
        logger.warn('Could not load user data:', err);
      }
      setForm(initialLogin);
      showStatus('success', 'Вы вошли в аккаунт.');
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Ошибка входа. Проверьте email и пароль.');
    } finally {
      setBusy(false);
    }
  };
  const handleYandexLogin = async () => {
    setBusy(true);
    setStatus(null);
    try {
      const data = await request('/api/v1/auth/oauth/yandex/start');
      if (!data?.authorization_url) {
        throw new Error('Yandex OAuth is unavailable');
      }
      window.location.href = data.authorization_url;
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось запустить вход через Яндекс.');
      setBusy(false);
    }
  };
  const handleVkLogin = async () => {
    setBusy(true);
    setStatus(null);
    try {
      const data = await request('/api/v1/auth/oauth/vk/start');
      if (!data?.authorization_url) {
        throw new Error('VK OAuth is unavailable');
      }
      window.location.href = data.authorization_url;
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось запустить вход через VK.');
      setBusy(false);
    }
  };
  return <form className="panel__form" onSubmit={handleSubmit} noValidate>
            <label>
                Email
                <input type="email" value={form.email} onChange={event => setForm({
        ...form,
        email: event.target.value
      })} autoComplete="email" required />

            </label>

            <label>
                Пароль
                <div className="input-with-toggle">
                    <input type={passwordVisible ? 'text' : 'password'} value={form.password} onChange={event => setForm({
          ...form,
          password: event.target.value
        })} autoComplete="current-password" required />


                    <button type="button" className="toggle" onClick={() => setPasswordVisible(prev => !prev)} aria-label={passwordVisible ? 'Скрыть пароль' : 'Показать пароль'}>
                        {passwordVisible ? (
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                          </svg>
                        ) : (
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                            <circle cx="12" cy="12" r="3"/>
                          </svg>
                        )}
                    </button>
                </div>
            </label>

            <button type="submit" disabled={busy}>
                Войти
            </button>

            <Link className="button-link" to="/password-reset/request">
                Забыли пароль?
            </Link>

            {SOCIAL_LOGIN_ENABLED && (
                <>
            <button type="button" className="ghost auth-provider-button" onClick={handleYandexLogin} disabled={busy}>
                <YandexIcon />
                <span>Войти через Яндекс</span>
            </button>

            <button type="button" className="ghost auth-provider-button" onClick={handleVkLogin} disabled={busy}>
                <VkIcon />
                <span>Войти через VK</span>
            </button>
                </>
            )}
        </form>;
}
export default LoginForm;
